module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "c-steps"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('li', {
      key: status.name,
      staticClass: "c-steps__item",
      class: {
        'is-finished': !!_vm.order[status.name]
      }
    }, [_c('div', {
      staticClass: "c-steps__media"
    }, [_c('span', {
      staticClass: "c-steps__count"
    }, [_c('i', {
      class: status.icon
    })])]), _vm._v(" "), _c('div', {
      staticClass: "c-steps__content"
    }, [_c('div', {
      staticClass: "c-steps__title"
    }, [_vm._v(_vm._s(_vm.$t(status.name).label))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d7956c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Shared/Stepper.vue
// module id = 3049
// module chunks = 0